import { Text } from '@chakra-ui/react';

export default function Bold(props) {
  return <Text as="span" fontWeight="bold">{props.children}</Text>;
}
